import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "position", "getMenuAttributes", "getMenuDescription", "getMenuDisabled", "getMenuIcon", "getMenuKey", "getMenuLabel", "getMenuOnClick", "getMenuRef", "getMenuTagName", "onMenuClick", "onMenuButtonClick", "className", "closeMenuOnScroll"];
import React, { useEffect } from 'react';
import { useFlag } from '@carnica/utils/hooks';
import { cnBem } from '@carnica/utils';
import { AnimatedIconProvider, IconCloseRoundStroked, defineAnimatedIcon } from '@carnica/graphics';
import { Menu } from "../../Menu";
import { Button } from "../../Button";
import styles from "./styles.pcss";
import { useMenuNavigation } from "../hooks/useMenuNavigation";
var cnTabBarMenu = cnBem('tabbar-menu', styles);
var Icon = defineAnimatedIcon({
  icons: [IconCloseRoundStroked],
  rotations: [45, 180],
  transition: 300
});
export var TabBarMenu = function TabBarMenu(props) {
  var _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    position = props.position,
    getMenuAttributes = props.getMenuAttributes,
    getMenuDescription = props.getMenuDescription,
    getMenuDisabled = props.getMenuDisabled,
    getMenuIcon = props.getMenuIcon,
    getMenuKey = props.getMenuKey,
    getMenuLabel = props.getMenuLabel,
    getMenuOnClick = props.getMenuOnClick,
    getMenuRef = props.getMenuRef,
    getMenuTagName = props.getMenuTagName,
    onMenuClick = props.onMenuClick,
    onMenuButtonClick = props.onMenuButtonClick,
    className = props.className,
    closeMenuOnScroll = props.closeMenuOnScroll,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isOpen = _useFlag2[0],
    setIsOpen = _useFlag2[1];
  var _useMenuNavigation = useMenuNavigation({
      isOpen: isOpen,
      closeMenu: setIsOpen.off,
      getMenuAttributes: getMenuAttributes,
      getMenuDisabled: getMenuDisabled,
      getMenuKey: getMenuKey,
      getMenuRef: getMenuRef,
      items: items
    }),
    getItemAttributes = _useMenuNavigation.getItemAttributes,
    getItemRef = _useMenuNavigation.getItemRef,
    buttonRef = _useMenuNavigation.buttonRef;
  useEffect(function () {
    if (closeMenuOnScroll) {
      window.addEventListener('scroll', setIsOpen.off);
    }
    return function () {
      return window.removeEventListener('scroll', setIsOpen.off);
    };
  }, [closeMenuOnScroll]);
  var handleMenuButtonClick = function handleMenuButtonClick(e) {
    onMenuButtonClick === null || onMenuButtonClick === void 0 ? void 0 : onMenuButtonClick(e);
    setIsOpen.toggle();
  };
  if (!items.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, position === 'fixed' && /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: cnTabBarMenu('overlay', {
      isOpen: isOpen
    }),
    "data-t-id": "TabBar-TabBarMenu"
  }), /*#__PURE__*/React.createElement(AnimatedIconProvider, {
    activeIndex: isOpen ? 1 : 0
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": isOpen ? 'закрыть меню' : 'открыть меню',
    className: cnTabBarMenu({
      isOpen: isOpen
    }, [className]),
    iconLeft: Icon,
    onClick: handleMenuButtonClick,
    onlyIcon: true,
    ref: buttonRef,
    size: "m",
    view: isOpen ? 'secondary-on-secondary' : 'primary',
    "data-t-id": "TabBar-TabBarMenu"
  })), /*#__PURE__*/React.createElement(Menu, _extends({
    anchorRef: buttonRef,
    className: cnTabBarMenu('menu', {
      fullWidth: position === 'fixed'
    }),
    getItemAttributes: getItemAttributes,
    getItemDescription: getMenuDescription,
    getItemDisabled: getMenuDisabled,
    getItemIcon: getMenuIcon,
    getItemKey: getMenuKey,
    getItemLabel: getMenuLabel,
    getItemOnClick: getMenuOnClick,
    getItemRef: getItemRef,
    getItemTagName: getMenuTagName,
    isOpen: isOpen,
    items: items,
    offsetHorizontal: position === 'fixed' ? -8 : -5,
    onClose: setIsOpen.off,
    onItemClick: onMenuClick,
    position: position === 'fixed' ? 'fixed' : 'absolute',
    reposition: position === 'default'
  }, otherProps)));
};